import { useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import { pendingRequestCount } from '@/lib/requestActivity';

// The animated intro paints before React. Release it after authentication and
// the first page's requests settle; subsequent navigation never shows it again.
export function StaffStartup() {
    const { checking } = useAuth();
    useEffect(() => {
        const screen = document.getElementById('pout-startup');
        if (!screen) return undefined;
        let quiet;
        let fade;
        const release = () => {
            screen.classList.add('pout-startup-leaving');
            fade = window.setTimeout(() => {
                if (screen.finishStartup) screen.finishStartup();
                else { screen.remove(); window.dispatchEvent(new Event('pout-startup-finished')); }
            }, 250);
        };
        const check = () => {
            clearTimeout(quiet);
            clearTimeout(fade);
            screen.classList.remove('pout-startup-leaving');
            if (!screen.isConnected) return;
            if (!checking && pendingRequestCount() === 0) quiet = setTimeout(release, 250);
        };
        window.addEventListener('pout-request-count', check);
        check();
        return () => {
            clearTimeout(quiet); clearTimeout(fade);
            screen.classList.remove('pout-startup-leaving');
            window.removeEventListener('pout-request-count', check);
        };
    }, [checking]);
    return null;
}
